export const CARD_PROVIDER_BADGE_VIEWBOX = '0 0 52 14';

export const CARD_PROVIDER_BADGE_THEME = {
	HUMO: { bg: '#2D3E4E', text: '#D4AF37' },
	UZCARD: { bg: '#1B3D7C', text: '#FFFFFF' },
	VISA: { bg: '#00579F', text: '#FFFFFF' },
} as const;

export type CardProviderBadgeName = keyof typeof CARD_PROVIDER_BADGE_THEME;
